module.exports = __webpack_public_path__ + "img/symbol_0.b4501a78.png";